module.exports = __webpack_public_path__ + "images/b42b5b9806c6bb357b91911e2e4e5514.jpg";